import type { TypedDocumentNode } from "@apollo/client";
import gql from "graphql-tag";

export type GetWarehousesListQuery = {
  getAllWarehouses: Array<{
    id: string
    name: string
    full_name: string | null
    ns_id: string | null
    created_at: string
    updated_at: string
    deleted_at: string | null
  }>
};

export const GET_WAREHOUSES_LIST: TypedDocumentNode<GetWarehousesListQuery> = gql`
  query getAllWarehouses {
    getAllWarehouses {
      id
      name
      full_name
      ns_id
      created_at
      updated_at
      deleted_at
    }
  }
`;

export type GetWarehouseBinsQuery = {
  getWarehouseBins: Array<{
    id: string
    name: string
    ns_id: string
  }>
};

export const GET_WAREHOUSE_BINS: TypedDocumentNode<
  GetWarehouseBinsQuery,
  { warehouseId: string | number }
> = gql`
  query getWarehouseBins($warehouseId: ID!) {
    getWarehouseBins(warehouseId: $warehouseId) {
      id
      name
      ns_id
    }
  }
`;

export type LocationZone = {
  id: string
  name: string
  ns_id: string | null
  warehouse_id: string | null
  warehouse_name: string | null
  created_at: string
  updated_at: string
  deleted_at: string | null
};

export type GetLocationZonesQuery = {
  getLocationZones: LocationZone[]
};

export const GET_LOCATION_ZONES: TypedDocumentNode<
  GetLocationZonesQuery,
  { warehouseId?: string | number | null }
> = gql`
  query getLocationZones($warehouseId: ID) {
    getLocationZones(warehouseId: $warehouseId) {
      id
      name
      ns_id
      warehouse_id
      warehouse_name
      created_at
      updated_at
      deleted_at
    }
  }
`;

// what a load from NetSuite changed
export type NetsuiteRefreshResult = {
  created: number
  updated: number
  deactivated: number
  skipped: number
};

export const REFRESH_WAREHOUSES_FROM_NETSUITE: TypedDocumentNode<
  { refreshWarehousesFromNetsuite: NetsuiteRefreshResult }
> = gql`
  mutation refreshWarehousesFromNetsuite {
    refreshWarehousesFromNetsuite {
      created
      updated
      deactivated
      skipped
    }
  }
`;

export const REFRESH_LOCATION_ZONES_FROM_NETSUITE: TypedDocumentNode<
  { refreshLocationZonesFromNetsuite: NetsuiteRefreshResult }
> = gql`
  mutation refreshLocationZonesFromNetsuite {
    refreshLocationZonesFromNetsuite {
      created
      updated
      deactivated
      skipped
    }
  }
`;
